/* eslint-disable react/prop-types */
import React from 'react';
import { RotatingLines } from 'react-loader-spinner';

const SmallLoading = ({ color, width, height }) => (
  <RotatingLines
    radius='9'
    wrapperStyle
    wrapperClass
    width={width || '32'}
    height={height || '32'}
    strokeColor={color || 'grey'}
    ariaLabel='three-dots-loading'
  />
);

export default SmallLoading;
